const options = {
  5: "bg-zinc-400/5",
  10: "bg-zinc-400/10",
  25: "bg-zinc-400/25",
  50: "bg-zinc-400/50",
  75: "bg-zinc-400/75",
  90: "bg-zinc-400/90",
  100: "bg-zinc-400",
};

const from = {
  5: "from-zinc-400/5",
  10: "from-zinc-400/10",
  25: "from-zinc-400/25",
  50: "from-zinc-400/50",
  75: "from-zinc-400/75",
  90: "from-zinc-400/90",
  100: "from-zinc-400",
};

export default function getBackgroundZinc400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
